export default __webpack_public_path__ + "6911022b6c4219dd012669f390327f10.svg";